module.exports = __webpack_public_path__ + "img/schgz-bg.9c88b33c.png";